import { useMemo } from 'react';

/**
 * Retorna dados no formato kanbanData agrupando usuários por tags.
 * @param {Array} users - Usuários, cada um com tag_user.
 * @param {Array} tags - Tags disponíveis.
 * @returns {Object} kanbanData { lanes: [...] }
 */
export default function useKanbanDataByTags(users = [], tags = []) {
  return useMemo(() => {
    // Map para agrupar usuários por tagId
    const tagIdToUsers = {};
    users.forEach(user => {
      if (Array.isArray(user.tag_user) && user.tag_user.length > 0) {
        user.tag_user.forEach(tag => {
          if (!tagIdToUsers[tag.id]) tagIdToUsers[tag.id] = [];
          tagIdToUsers[tag.id].push(user);
        });
      }
    });

    // Lanes para cada tag
    const lanes = tags.map((tag, idx) => {
      const usersWithTag = tagIdToUsers[tag.id] || [];
      return {
        id: tag.id,
        title: tag.name,
        label: String(usersWithTag.length),
        cards: usersWithTag.map(user => ({
          ...user,
          id: user.id,
          title: user.name,
          description: user.email,
          // tags: (user.tag_user || [])
          //   .filter(t => t.id === tag.id)
          //   .map(cardTag => ({
          //     id: cardTag.id,
          //     title: cardTag.name,
          //     bgcolor: cardTag.color,
          //     color: cardTag.text_color,
          //     idLinked: cardTag?.tagUserId || Math.random(),
          //     projectId: cardTag.projectId,
          //   })),
        })),
        bucketDescription: tag.description || '',
      };
    }).filter(lane => lane.cards.length > 0);

    // Lane para usuários sem tag
    const usersWithoutTag = users.filter(
      user => !Array.isArray(user.tag_user) || user.tag_user.length === 0
    );
    if (usersWithoutTag.length > 0) {
      lanes.push({
        id: 'no-tag',
        title: 'Sem Tag',
        label: String(usersWithoutTag.length),
        cards: usersWithoutTag.map(user => ({
          ...user,
          id: user.id,
          title: user.name,
          description: user.email,
          tags: [],
        })),
        bucketDescription: 'Usuários sem nenhuma tag associada.',
      });
    }

    return { lanes };
  }, [users, tags]);
}
